export const router = {
  LANDING: '/',
  HOME: '/home',
  QUESTION: '/question',
  GIFT_STORE: '/gift-store',
}
